import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../../context";

export const useCheckInOutTimeVisibilityField = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { isShowCheckInOutTime } = viewModel;

	const isEdited = isShowCheckInOutTime.isEdited;
	const hasError = Boolean(isShowCheckInOutTime.error);

	const onSetIsShowCheckInAndCheckOut = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "isShowCheckInOutTime",
					value: {
						...isShowCheckInOutTime,
						value: input,
					},
				},
			]);
		},
		[isShowCheckInOutTime, onSetViewModel],
	);

	return {
		isEdited,
		hasError,
		isShowCheckInAndCheckOut: isShowCheckInOutTime,
		onSetIsShowCheckInAndCheckOut,
	};
};
